import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Tooltip from 'components/common/Tooltip'
import BirthdayBanner from 'components/common/icons/BirthdayBanner'
import { calculateAge } from 'utils/patientUtils'

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginLeft: '12px'
  },
  text: {
    color: 'var(--text-color-6)',
    fontSize: '14px',
    fontWeight: 'normal'
  },
  birthdayEmoji: {
    fontSize: '16px'
  },
  tooltipTransparent: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    padding: 0
  },
  bannerContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 176,
    height: 30
  },
  bannerBackground: {
    position: 'absolute'
  },
  bannerText: {
    color: '#FFFFFF',
    fontSize: 12,
    lineHeight: '12px',
    whiteSpace: 'nowrap',
    zIndex: 1
  }
})

const PatientDemographic = ({ patient }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const demographics = useMemo(() => {
    if (!patient) return { text: null, isBirthday: false }

    const birthdate = patient?.details?.birthdate
    const { age, isBirthday } = calculateAge({ birthdate, ageRange: patient?.details?.ageRange })

    const genderText = patient?.gender ? t(`general.gender.${patient.gender}`) : null
    const ageText = age ? `${age}yo` : null

    const parts = [genderText, ageText].filter(Boolean)
    return {
      text: parts.length ? parts.join(', ') : null,
      isBirthday
    }
  }, [patient, t])

  if (!demographics.text && !demographics.isBirthday) return null

  const firstName = patient?.details?.name?.split(' ')[0] || t('general.patient')

  const birthdayTooltipValue = (
    <div className={classes.bannerContainer}>
      <BirthdayBanner className={classes.bannerBackground} />
      <span className={classes.bannerText}>
        {t('pages.patients.selectedPatient.header.birthdayTooltip', { name: firstName })}
      </span>
    </div>
  )

  return (
    <span className={classes.root}>
      {demographics.text && <span className={classes.text}>{demographics.text}</span>}
      {demographics.isBirthday && (
        <span className={classes.iconWrapper}>
          <Tooltip
            arrow={false}
            value={birthdayTooltipValue}
            placement="right"
            variant="light"
            tooltipContentClassName={classes.tooltipTransparent}
          >
            <span className={classes.birthdayEmoji}>🥳</span>
          </Tooltip>
        </span>
      )}
    </span>
  )
}

export default PatientDemographic
